export abstract class PrimariaNotificationService {
  abstract info(message: string): void;
  abstract warning(message: string): void;
  abstract error(message: string): void;
  abstract success(message: string): void;
}
